import TcModal from 'components/UI/Modal/TcModal';
import SlateEditor from 'components/UI/SlateEditor/SlateEditor';
import { FC } from 'react';

interface ICreateCustomerModal {
  visible: boolean;
  close(): void;
  richTextValue: any;
}

const TermsAndConditionsModal: FC<ICreateCustomerModal> = ({ visible, close, richTextValue }) => {
  return (
    <div className='relative'>
      <TcModal title='قوانین و ضوابط ' onCancel={close} footer={false} visible={visible} width={800}>
        <div className='overflow-auto h-[30rem] bg-t-layer-bg-color rounded-lg'>
          <SlateEditor value={richTextValue} setValue={() => {}} readOnly bgColor='bg-t-layer-bg-color ' />
        </div>
      </TcModal>
    </div>
  );
};

export default TermsAndConditionsModal;
